import { pipeFunctions } from '@web-config-app/core';
import { removeNullAndEmptyObjects } from '../remove-null-and-empty-objects/remove-null-and-empty-objects';
import { sanitizeEntityMetadataName } from '../sanitize-entity-metadata-name/sanitize-entity-metadata-name';
import { syncLocalizedArrayLengths } from '../sync-localized-array-lengths/sync-localized-array-lengths';

export const sanitizeAndSyncDataForRequest = (data: any) =>
  data
    ? pipeFunctions(
        removeNullAndEmptyObjects,
        syncLocalizedArrayLengths,
        sanitizeEntityMetadataName,
      )(data)
    : data;
